<template>
  <div class="wrap">
    <div class="myVue" v-cloak>
      <!-- 提示  -->
      <div class="saasTipBox" v-if="saasTipFalg">
        <div class="saasTip">
          <span>{{saasTipText}}</span>
        </div>
      </div>
      <div class="resultView" v-show="queryViewFalg==2">
        <div class="resultTop">
          <div class="topBox">
            <div class="iconImg">
              <img :src="biaoshiImg" />
            </div>
            <div class="title">
              <span>注册河北烹饪(服务)大师名师证书查询</span>
            </div>
          </div>
        </div>
        <div class="resultContain">
          <div class="resultList">
            <div class="resultBox" v-for="(item,index) in cxjt" :key="index">
              <div class="resultTitle">
                <span>{{item.lxmc}}</span>
              </div>
              <div class="resultInfo">
                <div class="infoLeft">
                  <img v-show="item.zszplj" :src="item.zszplj" />
                </div>
                <div class="infoRight">
                  <div class="rightBox">
                    <div class="info">
                      <span>姓名：</span>
                      <span>{{item.xm}}</span>
                    </div>
                    <div class="info">
                      <span>身份证：</span>
                      <span>{{item.sfzh}}</span>
                    </div>
                    <div class="info">
                      <span>性别：</span>
                      <span>{{item.xb}}</span>
                    </div>
                    <div class="info">
                      <span>申报项目：</span>
                      <span>{{item.lxmc}}</span>
                    </div>
                    <div class="info">
                      <span>编号：</span>
                      <span>{{item.zsbh}}</span>
                    </div>
                    <div class="info">
                      <span>认证时间：</span>
                      <span>{{item.rzsj}}</span>
                    </div>
                    <div class="info">
                      <span>发证时间：</span>
                      <span>{{item.fzsj}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="leftText">
              <span>河北省饭店烹饪餐饮行业协会 版权所有 ICP证：</span>
            </div>
            <div class="rightText">
              <span><a href="http://www.beian.miit.gov.cn" target="_blank">冀ICP备19032344号</a></span>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      queryViewFalg: 2, //1查询	2结果
      biaoshiImg: require("@/assets/biaoshi.png"),
      saasTipText: "", //提示的文本
      saasTipFalg: false, //提示框开关
      cxjt: ""
    };
  },
  computed: {
    ...mapGetters(["getcxjg"])
  },
  methods: {
    getCxjgObject() {
      this.cxjt = JSON.parse(window.sessionStorage.getItem("cxjgObject"));
    }
  },
  mounted() {
    this.getCxjgObject();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/cxjg.vue